import { render, staticRenderFns } from "./HomePageCompanies.vue?vue&type=template&id=25ab38ce&scoped=true&"
var script = {}
import style0 from "./HomePageCompanies.vue?vue&type=style&index=0&id=25ab38ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab38ce",
  null
  
)

export default component.exports